import ModalImageController from 'controllers/modal_image_controller'

export default class extends ModalImageController {
  options() {
    return {
      ...super.options(),
      descPosition: 'right',
      skin: 'newarrival_importdress',
    }
  }
}
